import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaEnvelope } from 'react-icons/fa';
import './ContactUs.css';

/**
 * ContactUs component - Displays contact information for AI Fire Defense
 * @returns {JSX.Element} The rendered contact us page
 */
const ContactUs = () => {
  const navigate = useNavigate();

  /**
   * Handles navigation back to previous page
   * @returns {void}
   */
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="contact-us-container">
      <div className="contact-us-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h1>Contact Us</h1>
      </div>
      <div className="contact-us-content">
        <div className="contact-info">
          <FaEnvelope className="email-icon" />
          <p>Contact us at <a href="mailto:ai-fire-defense@gblsys.com">ai-fire-defense@gblsys.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
